// Shared handle so the play UI can clear the running transcript without
// leaving Speech-to-Text. The active detector wires its reset in on load.
export const speechControl = { reset: () => {} }

// Live speech-to-text for the /vision play surface (Web Speech API). Builds a
// running transcript and shows it in the insights panel — no camera needed.
export default function createSpeechDetector() {
    let rec = null
    let running = false
    let transcript = ''
    let interim = ''

    const start = () => {
        const SR =
            (typeof window !== 'undefined' &&
                (window.SpeechRecognition ||
                    window.webkitSpeechRecognition)) ||
            null
        if (!SR || rec) return
        try {
            rec = new SR()
            rec.continuous = true
            rec.interimResults = true
            rec.lang = 'en-US'
            rec.onresult = (e) => {
                let finals = ''
                let interimText = ''
                for (let i = e.resultIndex; i < e.results.length; i++) {
                    const r = e.results[i]
                    if (r.isFinal) finals += r[0].transcript
                    else interimText += r[0].transcript
                }
                if (finals.trim())
                    transcript = (transcript + ' ' + finals.trim()).trim()
                interim = interimText
            }
            rec.onend = () => {
                if (running) {
                    try {
                        rec.start()
                    } catch (_) {
                        /* ignore */
                    }
                }
            }
            rec.onerror = () => {}
            rec.start()
            running = true
        } catch (e) {
            running = false
        }
    }

    const stop = () => {
        running = false
        if (rec) {
            try {
                rec.onend = null
                rec.stop()
            } catch (_) {
                /* ignore */
            }
        }
        rec = null
    }

    // Clear the transcript AND discard the recognizer's in-flight utterance.
    // Just clearing the strings isn't enough: an utterance already being
    // recognised when Reset is pressed finalises a moment later and re-appends
    // the "cleared" text. abort() drops that buffered audio; onend then restarts
    // recognition fresh (running stays true), so new speech starts clean.
    const doReset = () => {
        transcript = ''
        interim = ''
        if (rec) {
            try {
                rec.abort()
            } catch (_) {
                /* onend restarts it */
            }
        }
    }

    return {
        id: 'speech',
        label: 'Speech to Text',
        accent: '#06b6d4',

        async load() {
            start()
            speechControl.reset = doReset
        },

        async detect() {
            const full = (transcript + ' ' + interim).trim()
            return {
                boxes: [],
                insights: [
                    { label: 'Listening', value: running ? 'YES' : 'NO' },
                    { label: 'Transcript', value: full ? full.slice(-90) : '—' },
                ],
            }
        },

        reset() {
            doReset()
        },
        dispose() {
            stop()
        },
    }
}
